<template>
  <div class="employeeRoster page_fnnfield">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead/></div>
        <div class="screenInputs">
          <div class="screenInput">
            <div style="width:80px">字段名称</div>
            <el-input size="small" v-model="listQuery.coluname" @keyup.enter.native="getImportFiledList()"></el-input>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="isCanHandle" type="primary" plain size="small" @click="importHandle">上传模板</el-button>
        <el-button v-if="isCanHandle" type="success" plain size="small" @click="downLoadHandle">下载模板</el-button>
      </div>
    </div>

    <div class="main-con">
      <div class="page_breads">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务管理</el-breadcrumb-item>
          <el-breadcrumb-item>财务导入字段管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="crumbs">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane label="项目收支表客服" name="first"></el-tab-pane>
        <el-tab-pane label="项目收支表社保" name="second"></el-tab-pane>
        <el-tab-pane label="项目收支表费用" name="third"></el-tab-pane>
        <el-tab-pane label="利润表" name="four"></el-tab-pane>
        <el-tab-pane label="项目开票信息表" name="five"></el-tab-pane>
      </el-tabs>
      </div>
      <div class="employeeRosterTable">
        <el-table :data="tableData"  :max-height="tableHeight-180" style="width: 99%" v-loading="listLoading">
          <!-- <el-table-column align="center" type="selection" width="40px"></el-table-column> -->
          <el-table-column align="center" label="序号" prop="IntOrderId" width="100px"></el-table-column>
          <el-table-column label="字段名称" prop="StrColumName"></el-table-column>
          <el-table-column label="字段类型" prop="StrColumnType"></el-table-column>
          <el-table-column label="所属表格" prop="StrTableName"></el-table-column>
          <!-- <el-table-column label="操作" align="center" fixed="right">
            <template slot-scope="scope">
              <button class="changeState" style="margin-right:10px" @click="editImportFiled(scope.row)">修改</button>
            </template>
          </el-table-column> -->
        </el-table>

        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
           @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="Number(listQuery.pagecount)"
            layout="total,sizes,prev,pager, next, jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <!-- 上传模板 -->
      <el-dialog :visible.sync="importDialog" width="500px" class="up_dialog">
        <div class="diaTitle">上传模板</div>
        <div class="info_sel">
            <el-select
              v-model="uploadQuery.tableid"
              slot="prepend"
              placeholder="请选择要导入的表格类型"
              filterable
              @change="selectObj"
            >
              <el-option
                v-for="(item, index) in tableList"
                :key="index"
                :label="item.StrTableName"
                :value="item.StrTableId"
              ></el-option>
            </el-select>
          </div>
        <div class="form-item" style="justify-content: space-between;">
            <div class="file-box">
              <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
              <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
              <label for="fileInput" class="file-btn">上传</label>
            </div>
          </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="importDialog=false">取消</button>
          <button  class="search"  style="margin-left:10px;font-weight:600"  @click="confirmImport()">确认上传</button>
        </span>
      </el-dialog>
      <!-- 下载模板 -->
      <el-dialog :visible.sync="downloadDialog" width="500px" class="up_dialog">
        <div class="diaTitle">下载模板</div>
        <div style="margin:40px 0">
            <el-select
              v-model="downloadQuery.tableid"
              slot="prepend"
              placeholder="请选择要下载的表格类型"
              filterable
              @change="selectObj"
            >
              <el-option
                v-for="(item, index) in tableList"
                :key="index"
                :label="item.StrTableName"
                :value="item.StrTableId"
              ></el-option>
            </el-select>
          </div>
        <span slot="footer" class="dialog-footer">
          <button class="clear" @click="downloadDialog=false">取消</button>
          <button  class="search"  style="margin-left:10px;font-weight:600"  @click="downloadConfirm()">下载模板</button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import FUN from "../../fun";
import xz from "../../common";
// import selMonth from "./../../components/SelectMonth.vue";
export default {
  // components: {
  //   selMonth
  // },
  data() {
    return {
      downloadDialog:false,
      tablePath: this.$store.state.EMP.tablePath,
      tableHeight:0,
      listLoading:false,
      totalcount: null,
      dialogVisible2: false,
      tableData: [],
      //导入弹窗
      importDialog:false,
      ExcelSrc: {
        value: "",
        check: false,
        fileName: ""
      },
      //错误提醒
      errorTxt:'',
      //字段列表参数
      listQuery:{
        pagecount: 10,
        currpage: 1,
        tablename: "",
        coluname: "",
        strisfixed: "all",//strisfixed=1 固定字段 strisfixed=0 自定义拓展字段  all所有
        strTableId:'XZ_emp_Fnnc'
      },
      //切换tab
      activeName: 'first',
      //导入的表格参数
      infoQuery:{
        pagecount: 1000,
        currpage: 1,
        tablename: "",
        ctluserid: "",
        strTableId:''
      },
      tableList:[],
      //上传参数
      uploadQuery:{
        fileid:'',
        url:'',
        tableid:''
      },
      //下载模板参数
      downloadQuery:{
        fileid:'',
        tableid:''
      },
      selMonth:'',
      // 按钮权限参数
      butQuery:{
        roletype:'',
        page:'employee-fnnclst'
      },
      // 是否有权限操作按钮
      isCanHandle:false
    }
  },
  created() {
    this.butQuery.roletype = localStorage.loginRoletype
    this.getButtonPower()
    this.infoQuery.strTableId = localStorage.strTableId
    this.calHeight()
    this.getTabInfo()
    this.getImportFiledList()
  },
  methods: {
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight);
    //   console.log('height',this.tableHeight) 
    },
    //切换tab
    async handleClick(tab, event) {
      // console.log('tab',tab, event);
      if(tab.index == '0'){
        //项目收支表客服
        this.listQuery.strTableId = 'XZ_emp_Fnnc'
      }if(tab.index == '1'){
        //项目收支表社保
        this.listQuery.strTableId = 'XZ_emp_FnncSocialInsu'
      }if(tab.index == '2'){
        //项目收支表费用
        this.listQuery.strTableId = 'XZ_emp_FnncProCost'
      }if(tab.index == '3'){
        //利润表
        this.listQuery.strTableId = 'XZ_emp_FnncProfit'
      }if(tab.index == '4'){
        //项目开票信息表
        this.listQuery.strTableId = 'XZ_emp_FnncProjectInvoice'
      }
      this.listQuery.currpage = 1
      this.getImportFiledList()
    },
    //获取导入表格
    getTabInfo() {
      xz.getfinanceemptabledef(this.infoQuery).then(res => {
        // console.log("ddd", res);
        this.tableList = res.data;
      });
    },
    // 获取按钮权限
    getButtonPower(){
      xz.getJbUserRolepageDetail(this.butQuery.roletype, this.butQuery.page).then(res => {
          // console.log('按钮',res)
          if(res.status == 'ok'){
            let powerVal  = res.msg[0].Buttons
            if(powerVal == 'search'){
              // 只能查看
              this.isCanHandle = false
            }else if(powerVal == 'update'){
              // 特殊处理 只能更改客服
              this.isCanHandle = false
            }else if(powerVal == 'operation'){
              // 可操作
              this.isCanHandle = true
            }
          }else{
            this.isCanHandle = false
          }
        })
    },
     selectObj(e) {
      // console.log("d", e);
      let obj = {}
      this.tableList.map((item) => { 
        if(item.StrTableId === e) {
          obj = item
        }
      })
      // console.log('obj',obj)
      if(this.importDialog == true){
        this.uploadQuery.tableid = e
        this.uploadQuery.fileid = obj.StrTableName
      }
      if(this.downloadDialog == true){
        this.downloadQuery.tableid = e
        this.downloadQuery.fileid = obj.StrTableName
      }
    },
    //下载模板
    downLoadHandle(){
      this.downloadDialog = true
      this.downloadQuery = {
        fileid:'',
        tableid:''
      }
    },
    downloadConfirm(){
      // console.log('下载模板',this.downloadQuery)
      xz.getfinanceinputmode(this.downloadQuery.fileid,'output_'+this.downloadQuery.tableid).then(res=>{
        // console.log('下载模板',res)
        if(res){
          let d = res.msg.data.StrOutPath;
          let path = this.tablePath + d;
          console.log('path',path)
          const aTag = document.createElement('a')
          aTag.href = path
          aTag.click()
          this.downloadDialog = false
        }else{
           this.$message.warning('下载模板错误，请稍后再试')
        }
      })
    },
    //字段列表
    getImportFiledList(){
      this.listLoading = true
      // console.log('hh',this.listQuery)
      xz.getfinanceempcolumninf(this.listQuery).then(res =>{
        if(res){
          this.tableData = res.data;
          this.totalcount = parseInt(res.totalcount);
          this.num = this.totalcount + 1 + 52;
        }else{
          this.tableData = []
          this.totalcount = 0
        }
        this.listLoading = false
      })
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.listQuery.currpage = parseInt(val);
      this.getImportFiledList();
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.currpage = 1
        this.listQuery.pagecount = parseInt(val);
        this.getImportFiledList();
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 0 || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
    },
    //文件读取
    importf() {
      const fileInput = this.$refs.upload;
      FUN.returnExcelSrc(fileInput).then(src => {
        if (src) {
          // console.log('src0o0',src)
          this.$set(this.ExcelSrc, "value", src.src);
          this.$set(this.ExcelSrc, "check", false);
          this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
          // console.log('srccc',this.ExcelSrc)
           //上传excel
            const excelFile = FUN.base64ToFile(this.ExcelSrc.value,this.ExcelSrc.fileName);
            const formData = new FormData();
            formData.append("pagename", 'empexcel');
            formData.append("action", 'save');
            formData.append("userid", Cookies.get("userid-b"));         
            formData.append("entid", Cookies.get("userid-b"));
            formData.append("excel", excelFile , this.ExcelSrc.fileName);
            console.log('formData',formData)
            xz.uploadCert(formData).then(res => {
              console.log('formData',res)
              // this.uploadQuery.url = res;
              if(this.isNull(res)||res==false){
                this.$message('上传Excel失败!')
                this.isUploadSuccess = true
              }else{
                this.uploadQuery.url = res;
                this.isUploadSuccess = false
                 this.errorTxt = ''
                 this.$refs['upload'].value = null;
              }
            });
        }else{
            this.$message('上传Excel失败!')
          }
      });
    },
     //导入弹窗
    importHandle(){
      this.importDialog = true;
      this.ExcelSrc = {
        value: "",
        check: false,
        fileName: ""
      }
      this.uploadQuery = {
        fileid:'',
        url:'',
        tableid:''
      }
      this.errorTxt = ''
    },
    //确认上传
    confirmImport(){
      // console.log('上传',this.uploadQuery)
      if(this.isNull(this.uploadQuery.tableid)){
        this.$message.warning('请选择模板的类型')
        return false
      }else{
        if(this.uploadQuery.url){
          xz.getfinanceexprotmode(this.uploadQuery.fileid,this.uploadQuery.url,'output_'+ this.uploadQuery.tableid).then(res=>{
            if(res){
              this.importDialog = false;
              this.$message.success('上传成功！')
            }
          })
        }else{
          this.$message.warning('请先上传模板')
        }
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.top-right {
  display: flex;
  align-items: center;
  margin-right: 16px;
}
.form-item {
  width: 100%;
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #333333;
  margin-bottom: 20px;
}

.form-item label {
  width: 56px;
  text-align: right;
}

.form-item span {
  color: #ff3228;
}

.form-item input {
  width: 400px;
  height: 40px;
  line-height: 40px;
  border: 1px solid #cccccc;
  padding-left: 14px;
  box-sizing: border-box;
  margin-top: 20px;
}

/* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
#fileInput {
  width: 120px;
  margin-left: 8px;
  filter: Alpha(opacity=0);
  -moz-opacity: 0;
  opacity: 0;
  position: absolute;
  right: 37px;
  z-index: 2;
}
/* 这是主要的，文件上传按钮的样式 */
.file-btn {
  display:inline-block;
  width: 54px;
  height: 30px;
  background: #fff;
  border: 1px solid #ccc;
  text-align: center !important;
  line-height: 32px;
  color: #333333;
  margin-left: 8px;
}
/* 单行文字截断，展示文件名的input框用的 */
#applyLicense {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>

<style>
.page_breads{
  margin-top: 20px;
}
.info_sel{
  margin-top: 30px;
}
.info_sel .el-select{
  width: 368px;
}
.info_sel .el-input__inner{
  height: 32px;
  line-height: 32px;
}
.info_sel .is-focus .el-input__suffix{
  top: -4px;
}
.info_sel .el-input__suffix{
  top: 5px;
}
.up_dialog .el-dialog__body .el-input__inne{
  height: 40px;
  line-height: 40px;
}
.up_dialog .el-dialog__body .el-select{
  width: 80%;
}
.page_fnnfield .el-tabs__header{
  margin: 0;
}
.page_fnnfield .crumbs{
  margin-top: 20px;
  margin-bottom: 1px;
  background-color: #fff;
}
.screenInput .el-input {
  width: 70%;
  margin-left: 5px;
}
.storageArea .upload-demo {
  height: 32px !important;
}
.storageArea .el-button--primary {
  background-color: #fff;
  color: #000;
  border-color: #ccc;
}
.delFiledItem [class*=" el-icon-"], .delFiledItem [class^=el-icon-] {
  line-height: 56px;
}
</style>